
import React, { useEffect, useRef } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";
import { toast } from "@/lib/toast";

export const AdminProtectedRoute = () => {
  const { user, isLoading, isAdmin } = useAdminAuth();
  const deniedToastShownRef = useRef(false);

  useEffect(() => {
    if (!isLoading && user && !isAdmin && !deniedToastShownRef.current) {
      toast.error("Acesso negado. Este painel é restrito para administradores.");
      deniedToastShownRef.current = true;
    }

    if (!user || isAdmin) {
      deniedToastShownRef.current = false;
    }
  }, [isLoading, user, isAdmin]);

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mb-4"></div>
        <div className="text-lg font-medium text-gray-700">Verificando permissões...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/admin/access-denied" replace />;
  }

  return <Outlet />;
};
